export interface Category {
  slug: string;
  name: string;
  enName: string;
  icon: string;
  tone: 'primary' | 'accent' | 'secondary';
  count: number;
}

export const categories: Category[] = [];
